<template>
  <v-container fluid fill-height="fill-height">
    <v-row>
      <v-col cols="12" md="6" lg="8">
        <ContactForm/>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-card flat class="h-100 bg-transparent">
          <v-card-text class="pa-0 ma-0">
            <ContactInfo/>
            <Management/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import ContactForm from '@/components/public/contact/ContactForm';
  import ContactInfo from '@/components/public/contact/ContactInfo';
  import Management from '@/components/public/contact/Management';
  export default {
    name: "home",
    components: { 
      ContactForm,
      ContactInfo,
      Management
    }
  };
</script>